import * as ng from '@angular/core';
import {Component} from '@angular/core';
import * as Rx from 'rxjs';
import {Live} from "../../../lib/entity/live";
import {SubscribingHistory} from "../../../lib/entity/magazine";
import {Router} from "@angular/router";
import {filter, map} from "rxjs/operators";
import {MagliveApiClient} from "../../../lib/api-client/maglive-api-client";
import {MagticketApiClient} from "../../../lib/api-client/magticket-api-client";
import {LiveTicketOrder} from "../../../lib/entity/live";
import {environment} from "../../../env/environment";
import { type } from 'jquery';
import { ThrowStmt } from '@angular/compiler';

@Component({
  selector: 'maglive-live-card',
  styleUrls: [
    './live-card.component.scss'
  ],
  templateUrl: './live-card.component.html'
})
export class LiveCardComponent {

  private _live: Live;
  private _histories: SubscribingHistory[];
  private _archiveLimitTimestamp: Date
  private activeSubscriber: boolean

  title: string;
  thumbnailURL: string;
  spentTime$: Rx.Observable<string> | undefined;
  scheduledAt: string | undefined;
  startedAt: string | undefined;
  archiveLimit: string;
  tickets: LiveTicketOrder[] | undefined;
  showTicketModal: boolean;

  get live(): Live {
    return this._live;
  }

  get histories(): SubscribingHistory[] {
    return this._histories;
  }

  private get today(): Date {
    return new Date()
  }

  get isUnavailableArchive(): boolean {
    if (this.live.status !== 'CLOSED' && this.live.status !== 'FORCE_STOPPED') {
      return false
    }
    if (this.live.options.isArchived) {
      return !(
        (this.live.options.viewerSegment === 'ALL' ||
          this.live.options.viewerSegment === 'TICKET' ||
          (this.live.options.viewerSegment === 'SUBSCRIBER' && this.isSubscribed)) &&
        (this.live.options.archiveDays === 0 || this.today <= this._archiveLimitTimestamp))
    } else {
      return true
    }
  }

  get isSubscribed(): boolean {
    return Boolean(this.histories
      .filter(x => x['magazineId'] === this.live.magazineId)
      .filter(x => 
        x['histories']
          .filter(h =>
            new Date(h['from']) <= this.live.startedAt.toDate() &&
            (h['to'] ? this.live.startedAt.toDate() <= new Date(h['to']) : true)
          )
          .length
      ).length)
  }

  @ng.Input()
  set live(live: Live) {
    this._live = live;
    this.title = live.title
      ? live.title
      : live.scheduledAt
        ? new Date(live.scheduledAt.seconds * 1000).toLocaleString() + " の配信"
        : new Date(live.createdAt.seconds * 1000).toLocaleString() + " の配信"
    this.thumbnailURL = MagliveApiClient.getLiveThumbnailURL(live)
    if (live.startedAt && (live.status === 'ON_AIR' || live.status === 'NO_STREAM')) {
      this.spentTime$ = Rx.interval(1000).pipe(map(() => {
        const spentTimeSecond = Math.floor((new Date().getTime() - live.startedAt.toDate().getTime()) / 1000)
        const seconds = spentTimeSecond % 60
        const minutes = (spentTimeSecond - seconds) % 3600 / 60
        const hours = (spentTimeSecond - seconds - (minutes * 60)) / 3600
        if (2 <= hours.toString().length) {
          return hours + ":" + ('00' + minutes).slice(-2) + ":" + ('00' + seconds).slice(-2);
        }
        return ('00' + hours).slice(-2) + ":" + ('00' + minutes).slice(-2) + ":" + ('00' + seconds).slice(-2);
      }))
    }
    if (live.status === 'RESERVED' && live.scheduledAt) {
      const date = live.scheduledAt.toDate();
      this.scheduledAt = date.getFullYear() + '/' + (date.getMonth() + 1) + "/" + date.getDate() + " " + date.getHours() + ":" + ('00' + date.getMinutes()).slice(-2);
    }
    if (live.status === 'CLOSED' && live.finishedAt) {
      const date = live.startedAt.toDate();
      this.startedAt = date.getFullYear() + '/' + (date.getMonth() + 1) + "/" + date.getDate() + " " + date.getHours() + ":" + ('00' + date.getMinutes()).slice(-2);
      this._archiveLimitTimestamp = new Date(date.setDate(date.getDate() + this.live.options.archiveDays))
      this.archiveLimit = this._archiveLimitTimestamp.getFullYear() + '/' + (this._archiveLimitTimestamp.getMonth() + 1) + "/" + this._archiveLimitTimestamp.getDate();
    }
  }

  @ng.Input()
  layout: "vertical" | "horizontal" = "vertical";

  @ng.Input()
  set histories(histories: SubscribingHistory[]) {
    this._histories = histories;
  }

  constructor(
    private router: Router
  ) {
  }

  onLiveClick($event) {
    if ($event) {
      $event.stopPropagation()
    }
    if (this.live.status === 'CLOSED' || this.live.status === 'FORCE_STOPPED') {
      if (this.live.options.isArchived === true) {
        if (!this.isUnavailableArchive){
          if (this.live.options.viewerSegment === 'TICKET') {
            this.checkTicket(() => {
              this.showDownloadDialog();
            }, () => {
              alert("チケット限定配信のため視聴できません。")
            });
          } else {
            this.showDownloadDialog();
          }
          return false
        }
        if (this.live.options.viewerSegment !== 'ALL' && (this.live.options.viewerSegment === 'SUBSCRIBER' && !this.activeSubscriber)) {
          alert("アーカイブは視聴できません。 このライブは読者限定です。");
          return false
        }
        if (this.live.options.archiveDays !== 0 && this.today >= this._archiveLimitTimestamp) {
          alert("アーカイブは視聴できません。 このライブは公開期限切れです。");
          return false
        }
      }
      alert('アーカイブは視聴できません。このライブは非公開です。');
      return false
    }
    if (this.live.options.viewerSegment === 'TICKET') {
      this.checkTicket(() => {
        Rx.from(this.router.navigate(['lives', this.live.id])).subscribe();
      });
    } else {
      Rx.from(this.router.navigate(['lives', this.live.id])).subscribe();
    }
  }

  checkTicket(success, failiure = null) {
    MagticketApiClient.getTickets(this.live.ticketEventId)
      .pipe(filter(x => x !== 'NOT_FOUND'))
      .subscribe(x => {
        if (x.length) {
          success(x)
        } else {
          if (failiure) {
            failiure(x)
          } else {
            this.showTicketModal = true;
          }
        }
      })
  }

  showDownloadDialog() {
    const res = confirm("過去の配信はアプリからお楽しみいただけます。\nアプリのダウンロードページに遷移しますか？");
    if (res) {
      if (navigator.userAgent.match(/Android/)) {
        location.href = 'https://i.mag2.jp/r?aid=a5e85a9e849d04'
      } else {
        location.href = 'https://i.mag2.jp/r?aid=a5da01a06e0bdf'
      }
    }
  }

  onMagazineClick() {
    Rx.from(this.router.navigate(['magazines', this.live.magazineIdView])).subscribe();
  }

  onTicketModalClose() {
    this.showTicketModal = false
  }

  onTicketPurchaseClick() {
    this.showTicketModal = false
    const url = environment.baseURL.magticketWeb + `customer/event/${this.live.ticketEventId}/`
    window.open(url);
  }
}
